import Vue from 'vue'
import router from './router'
import store from './store'
// import queryString from 'query-string'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
// import notification from 'ant-design-vue/es/notification'
import {
  setDocumentTitle,
  domTitle
} from '@/utils/domUtil'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = [] // no redirect whitelist
// const defaultRoutePath = '/sitesEditor/list'

router.beforeEach((to, from, next) => {
  if ((to.fullPath.indexOf('guide') !== -1 || to.fullPath.indexOf('viewExam') !== -1) && to.fullPath.indexOf('#') !== -1 && to.fullPath.indexOf('?') !== -1) {
    const url = to.fullPath.split('#')[1]
    next({
      path: url
    })
  }
  const query = to.params
  if (query.token) {
    query.token = process.env.NODE_ENV === 'production' ? query.token : '6f747cea9bbf90718ddf1f1d1d349313'
    console.log(query.token)
    // query.token = '6f747cea9bbf90718ddf1f1d1d349313'
    Vue.ls.set(ACCESS_TOKEN, query.token)
    Vue.ls.remove('loginInfo')
    Vue.ls.set('loginInfo', query)
    store.commit('SET_TOKEN', query.token)
  }
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${domTitle}`))
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    next()
  } else {
    // console.log('验证白名单.......' + to.name)
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      // next()
    } else {
      // next({
      //   path: '/404'
      // })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
